<template>
    <a-select
        :get-popup-container="(triggerNode) => triggerNode.parentNode"
        :value="value"
        :disabled="!!disabled"
        :filter-option="filter"
        style="width: 100%;"
        show-search
        @change="onChange"
    >
        <a-select-option
            v-for="item in store"
            :key="item.code"
            :value="item.code"
        >
            {{ item.name }}
        </a-select-option>
    </a-select>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        value: {
            type: String,
            default: '',
        },
        disabled: Boolean,
    },
    emits: ['input'],
    data() {
        return {
            store: [],
            allUsers: [],
        };
    },
    mounted() {
        this.loadStore();
    },
    methods: {
        loadStore() {
            this.$http.get('/patient/states').then((response) => {
                this.store = response.data;
            }, () => {});
        },
        onChange(value) {
            this.$emit('input', value);
        },
        filter(input, option) {
            if (!option.componentOptions.children[0].text) {
                return false;
            }

            return option.componentOptions.children[0].text
                .toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
    },
});
</script>

<style lang="scss">
.ant-select-dropdown-content {
    text-align: left;
}
</style>
